import { testimonials } from "@/mocks/homeData";

export default function TestimonialsSection() {
  const featured = testimonials.slice(0, 3);

  return (
    <section className="py-20 bg-white" id="testimonials">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-double-quotes-l text-[#9bc400] text-xs" />
              <span className="text-slate-500 text-xs font-semibold uppercase tracking-wider">Client Stories</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900">
              Trusted by Industry Leaders
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex -space-x-2">
              {["MT", "PS", "JK"].map((initials, i) => (
                <div key={i} className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center text-xs font-bold text-white bg-slate-700">
                  {initials}
                </div>
              ))}
            </div>
            <div>
              <div className="text-sm font-bold text-slate-900">500+ Clients</div>
              <div className="flex items-center gap-0.5">
                {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-[#C8F135] text-xs" />)}
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featured.map((t) => (
            <div key={t.id} className="bg-slate-50 border border-slate-100 rounded-xl p-7 hover:border-[#C8F135]/50 transition-colors">
              <div className="flex items-center gap-0.5 mb-5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <i key={idx} className="ri-star-fill text-[#C8F135] text-sm" />
                ))}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed mb-6 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center text-xs font-black text-white bg-slate-800 flex-shrink-0">
                  {t.avatar}
                </div>
                <div>
                  <div className="text-sm font-bold text-slate-900">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
